import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import AppBar from '@material-ui/core/AppBar'
import CssBaseline from '@material-ui/core/CssBaseline'
import Divider from '@material-ui/core/Divider'
import Drawer from '@material-ui/core/Drawer'
import Hidden from '@material-ui/core/Hidden'
import IconButton from '@material-ui/core/IconButton'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import MenuIcon from '@material-ui/icons/Menu'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import AccountCircle from '@material-ui/icons/AccountCircle'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import Banner from '../banner/banner'
import { Button, Grid, Avatar } from '@material-ui/core'
import ExitToAppRoundedIcon from '@material-ui/icons/ExitToAppRounded'
import UserCard from '../holdCoCard/users/userCard'
import Popover from '../popover/popover'
import { getData } from '../actions'
import { useHistory } from 'react-router-dom'
import AdminModal from '../../MasterData/adminModal'

import { AzureAD, AuthenticationState } from 'react-aad-msal'
import { authProvider } from '../../../authProvider.js'

const drawerWidth = 240

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex'
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0
    }
  },
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth
    }
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none'
    }
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: '#222',
    color: '#999'
  },
  content: {
    width: '100%',
    padding: theme.spacing(2)
  },
  title: {
    flexGrow: 1
  },
  nested: {
    paddingLeft: theme.spacing(4)
  },
  active: {
    color: 'lightblue'
  }
}))

const handleLogout = logout => {
  localStorage.removeItem('jwt')
  localStorage.removeItem('userFirstName')
  localStorage.removeItem('userLastName')
  localStorage.removeItem('userEmail')
  logout()
  localStorage.removeItem('token')

  window.location.reload()
}

function ResponsiveDrawer (props) {
  const history = useHistory()
  const { window } = props
  const classes = useStyles()
  const theme = useTheme()
  const [mobileOpen, setMobileOpen] = React.useState(false)
  const [open, setOpen] = React.useState(false)
  const [myAccount, setMyAccount] = React.useState({})
  const [popover, setPopover] = React.useState(null)

  useEffect(() => {
    getMyAccount()
  }, [])

  const getMyAccount = async () => {
    const { data } = await getData('/userInfo')
    setMyAccount(data)
  }
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  const handleDropDown = () => {
    setOpen(!open)
  }

  const drawer = (
    <div>
      <div className={classes.toolbar}>
        <Banner name={props.name} role={props.role} />
      </div>
      <Divider color='primary' />
      <List>
        <ListItem
          button
          className={props.appBarHeader === 'EPC' ? classes.active : null}
          onClick={() => props.clicked('EPC')}
        >
          <ListItemText primary='EPC' align='center' />
        </ListItem>
        <ListItem button onClick={() => setOpen(true)}>
          <ListItemText primary='Master Data' align='center' />
        </ListItem>
        {/* <ListItem button onClick={handleDropDown} className={classes.nested}>
          <ListItemText primary='Hold Co' />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={open} timeout='auto' unmountOnExit>
          <List component='div' disablePadding>
            <ListItem button>
              <ListItemIcon></ListItemIcon>
              <ListItemText primary='Users' />
            </ListItem>
            <ListItem button>
              <ListItemIcon></ListItemIcon>
              <ListItemText primary='Projects' />
            </ListItem>
            <ListItem button>
              <ListItemIcon></ListItemIcon>
              <ListItemText primary='Departments' />
            </ListItem>
          </List>
        </Collapse> */}
      </List>
    </div>
  )

  const container =
    window !== undefined ? () => window().document.body : undefined

  return (
    <div className={classes.root}>
      <AdminModal
        fullScreen
        title='Master Data'
        handleClose={() => {
          setOpen(false)
        }}
        open={open}
      />
      <Popover anchorEl={popover} handleClose={() => setPopover(null)}>
        <AzureAD provider={authProvider}>
          {({ logout }) => {
            return (
              <UserCard
                imageUrl={myAccount.imageUrl}
                name={`${myAccount.firstName} ${myAccount.lastName}`}
                email={myAccount.email}
                role='System Admin'
                departments={[]}
                actions={e => {
                  handleLogout(logout)
                }}
                actionIcon={<ExitToAppRoundedIcon />}
              />
            )
          }}
        </AzureAD>
      </Popover>
      <CssBaseline />
      <AppBar position='fixed' className={classes.appBar}>
        <Toolbar>
          <IconButton
            color='inherit'
            aria-label='open drawer'
            edge='start'
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant='h6' noWrap className={classes.title}>
            {props.appBarHeader}
          </Typography>
          <IconButton
            aria-label='account of current user'
            aria-controls='menu-appbar'
            aria-haspopup='true'
            onClick={e => {
              setPopover(e.currentTarget)
            }}
            color='inherit'
          >
            <AccountCircle />
          </IconButton>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label='mailbox folders'>
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation='css'>
          <Drawer
            container={container}
            variant='temporary'
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper
            }}
            ModalProps={{
              keepMounted: true // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation='css'>
          <Drawer
            classes={{
              paper: classes.drawerPaper
            }}
            variant='permanent'
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        {props.children}
      </main>
    </div>
  )
}

ResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func
}

export default ResponsiveDrawer
